"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = require("styled-components");
const component_link_1 = require("@patternplate/component-link");
const component_text_1 = require("@patternplate/component-text");
exports.StyledResult = styled_components_1.default.div `
  position: relative;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  &:hover {
    mask-image: linear-gradient(
      to left,
      rgba(0, 0, 0, 0) 75px,
      rgba(0, 0, 0, 1) 125px
    );
    -webkit-mask-image: linear-gradient(
      to left,
      rgba(0, 0, 0, 0) 75px,
      rgba(0, 0, 0, 1) 125px
    );
  }
  &:hover {
    opacity: 1;
  }
`;
exports.StyledResultLink = styled_components_1.default(component_link_1.Link) `
  display: flex;
  align-items: center;
  width: 100%;
  padding: 10px 15px;
  &:link,
  &:visited,
  &:active {
    color: ${props => props.active ? props.theme.colors.active : props.theme.colors.color};
    text-decoration: none;
  }
`;
exports.StyledResultLinkText = styled_components_1.default(component_text_1.Text) `
  line-height: 20px;
  color: ${props => props.active ? props.theme.colors.active : props.theme.colors.color};
  text-decoration: none;
`;
exports.StyledPreviewLink = styled_components_1.default(component_link_1.Link) `
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  text-decoration: none;
  color: ${props => props.theme.colors.border};
  opacity: 0;
  &:hover {
    color: ${props => props.theme.colors.color};
    text-decoration: underline;
  }
`;
//# sourceMappingURL=search-result.styles.js.map